/**
 * Application Mutations
 */
export const APP_LOADING = 'APP_LOADING'
export const SET_NAVIGATION_COUNTS = 'SET_NAVIGATION_COUNTS'

/**
 * User Mutations
 */
export const SET_AUTHORIZED = 'SET_AUTHORIZED'
export const ADD_USERS = 'ADD_USERS'
export const ADD_USER = 'ADD_USER'
export const SET_USERS = 'SET_USERS'
export const RESET_USER = 'RESET_USER'
export const SET_USER = 'SET_USER'
export const SET_PENDING_USERS = 'SET_PENDING_USERS'
export const SET_USER_ATTRIBUTE = 'SET_USER_ATTRIBUTE'
export const SET_USERS_PAGINATION = 'SET_USERS_PAGINATION'
export const ADD_DOCUMENT = 'ADD_DOCUMENT'
export const REMOVE_DOCUMENT = 'REMOVE_DOCUMENT'
export const REPLACE_DOCUMENT = 'REPLACE_DOCUMENT'

/**
 * Carrier Mutations
 */
export const SET_CARRIERS = 'SET_CARRIERS'
export const PUSH_CARRIER = 'PUSH_CARRIER'

/**
 * Account User (children) Mutations
 */
export const SET_ACCOUNT_USERS = 'SET_ACCOUNT_USERS'
export const SET_ACCOUNT_USERS_PAGINATION = 'SET_ACCOUNT_USERS_PAGINATION'
export const ADD_ACCOUNT_USERS = 'ADD_ACCOUNT_USERS'
export const SET_ACCOUNT_USER_ATTRIBUTE = 'SET_ACCOUNT_USER_ATTRIBUTE'
export const SET_ACCOUNT_USER = 'SET_ACCOUNT_USER'
export const RESET_ACCOUNT_USER = 'RESET_ACCOUNT_USER'
export const ADD_ACCOUNT_USER = 'ADD_ACCOUNT_USER'

/**
 * Location Mutations
 */
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_LOCATIONS_LIST = 'SET_LOCATIONS_LIST'
export const ADD_LOCATIONS = 'ADD_LOCATIONS'
export const SET_LOCATIONS_PAGINATION = 'SET_LOCATIONS_PAGINATION'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_LOCATION_ATTRIBUTE = 'SET_LOCATION_ATTRIBUTE'
export const RESET_LOCATION = 'RESET_LOCATION'
export const ADD_LOCATION = 'ADD_LOCATION'

/**
 * Job Mutations
 */
export const SET_JOBS = 'SET_JOBS'
export const SET_JOBS_PAGINATION = 'SET_JOBS_PAGINATION'
export const ADD_JOBS = 'ADD_JOBS'
export const RESET_JOB = 'RESET_JOB'
export const RESET_JOBS = 'RESET_JOBS'
export const SET_JOB_ATTRIBUTE = 'SET_JOB_ATTRIBUTE'
export const SET_JOB = 'SET_JOB'
export const REMOVE_JOB = 'REMOVE_JOB'
export const SET_JOB_HISTORY = 'SET_JOB_HISTORY'
export const ADD_JOB = 'ADD_JOB'

/**
 * Load Mutations
 */
export const ADD_LOADS = 'ADD_LOADS'
export const SET_LOADS = 'SET_LOADS'
export const RESET_LOADS = 'RESET_LOADS'
export const SET_LOADS_PAGINATION = 'SET_LOADS_PAGINATION'
export const SET_LOAD = 'SET_LOAD'
export const SET_LOAD_ATTRIBUTE = 'SET_LOAD_ATTRIBUTE'
export const RESET_LOAD = 'RESET_LOAD'
export const ADD_LOAD = 'ADD_LOAD'
export const REMOVE_LOAD = 'REMOVE_LOAD'
export const ADD_EMPTY_LOAD = 'ADD_EMPTY_LOAD'
export const ADD_LOAD_CHARGE = 'ADD_LOAD_CHARGE'
export const REMOVE_LOAD_CHARGE = 'REMOVE_LOAD_CHARGE'
export const SET_TOKEN = 'SET_TOKEN'

/**
 * Weighbridge Mutations
 */
export const SET_WEIGHBRIDGE = 'SET_WEIGHBRIDGE'
export const SET_WEIGHBRIDGE_ATTRIBUTE = 'SET_WEIGHBRIDGE_ATTRIBUTE'
export const RESET_WEIGHBRIDGE = 'RESET_WEIGHBRIDGE'
export const SET_WEIGHBRIDGE_LOADS = 'SET_WEIGHBRIDGE_LOADS'
export const SET_WEIGHBRIDGE_LOADS_PAGINATION = 'SET_WEIGHBRIDGE_LOADS_PAGINATION'
export const SET_WEIGHBRIDGE_LOAD = 'SET_WEIGHBRIDGE_LOAD'
export const ADD_WEIGHBRIDGE_LOADS = 'ADD_WEIGHBRIDGE_LOADS'

/**
 * Docket Mutations
 */
export const SET_DOCKET = 'SET_DOCKET'
export const SET_DOCKET_ATTRIBUTE = 'SET_DOCKET_ATTRIBUTE'
export const RESET_DOCKET = 'RESET_DOCKET'
export const ADD_DOCKET = 'ADD_DOCKET'
export const REMOVE_DOCKET = 'REMOVE_DOCKET'

/**
 * Commodity Mutations
 */
export const SET_COMMODITIES = 'SET_COMMODITIES'
export const ADD_COMMODITY = 'ADD_COMMODITY'
export const REPLACE_COMMODITY = 'REPLACE_COMMODITY'

/**
 * Credit Note Mutations
 */
export const SET_CREDIT_NOTES = 'SET_CREDIT_NOTES'
export const ADD_CREDIT_NOTE = 'ADD_CREDIT_NOTE'
export const SET_ACCOUNT_CREDIT = 'SET_ACCOUNT_CREDIT'

/**
 * Driver Mutations
 */
export const ADD_DRIVERS = 'ADD_DRIVERS'
export const SET_DRIVERS = 'SET_DRIVERS'
export const SET_DRIVERS_PAGINATION = 'SET_DRIVERS_PAGINATION'
export const SET_DRIVER = 'SET_DRIVER'
export const ADD_DRIVER = 'ADD_DRIVER'
export const SET_DRIVER_ATTRIBUTE = 'SET_DRIVER_ATTRIBUTE'
export const RESET_DRIVER = 'RESET_DRIVER'
export const PUSH_DRIVER = 'PUSH_DRIVER'

/**
 * Truck Mutations
 */
export const ADD_TRUCKS = 'ADD_TRUCKS'
export const SET_TRUCKS = 'SET_TRUCKS'
export const PUSH_TRUCK = 'PUSH_TRUCK'
export const SET_TRUCKS_PAGINATION = 'SET_TRUCKS_PAGINATION'
export const SET_TRUCK = 'SET_TRUCK'
export const SET_TRUCK_ATTRIBUTE = 'SET_TRUCK_ATTRIBUTE'
export const RESET_TRUCK = 'RESET_TRUCK'
export const ADD_TRUCK_CONFIGURATION = 'ADD_TRUCK_CONFIGURATION'
export const REMOVE_TRUCK_CONFIGURATION = 'REMOVE_TRUCK_CONFIGURATION'

/**
 * Configuration Mutations
 */
export const SET_CONFIGURATIONS = 'SET_CONFIGURATIONS'

/**
 * Invoice Mutations
 */
export const SET_INVOICES = 'SET_INVOICES'
export const SET_INVOICES_PAGINATION = 'SET_INVOICES_PAGINATION'
export const ADD_INVOICES = 'ADD_INVOICES'
export const SET_INVOICE = 'SET_INVOICE'
export const RESET_INVOICE = 'RESET_INVOICE'

/**
 * Payment Mutations
 */
export const SET_PAYMENTS = 'SET_PAYMENTS'
export const SET_PAYMENTS_PAGINATION = 'SET_PAYMENTS_PAGINATION'
export const ADD_PAYMENTS = 'ADD_PAYMENTS'
export const SET_PAYMENT = 'SET_PAYMENT'
export const RESET_PAYMENT = 'RESET_PAYMENT'

/**
 * Terms Mutations
 */
export const SET_TERMS = 'SET_TERMS'
export const RESET_TERM = 'RESET_TERM'
export const SET_TERM = 'SET_TERM'
export const SET_TERM_ATTRIBUTE = 'SET_TERM_ATTRIBUTE'
export const SET_PUBLISHED_TERM = 'SET_PUBLISHED_TERM'

/**
 * Map Mutations
 */
export const RESET_MAP_DETAILS = 'RESET_MAP_DETAILS'

/**
 * Setting Mutations
 */
export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_SETTINGS_PROPERTY = 'SET_SETTINGS_PROPERTY'

export const SET_XERO_LINK = 'SET_XERO_LINK'
export const SET_XERO_DATA = 'SET_XERO_DATA'



// WEBPACK FOOTER //
// ./src/vuex/mutations.js